import { useEffect, useState } from "react";
import type { TipoHonorario } from "../../shared/types";
import { api } from "../lib/apiClient";
import { Input, Select } from "./Formulario";

// Combo catálogo-backed para honorarios.tipo_honorario — mismo patrón que
// el selector de Tipo de Actuación en PestanaActuaciones.tsx: se guarda el
// nombre (texto libre, sin FK), y si el catálogo no carga o está vacío se
// degrada a un <Input> de texto libre en vez de bloquear el formulario.
export function SelectorTipoHonorario({
  valor,
  onCambiar,
  disabled,
}: {
  valor: string;
  onCambiar: (valor: string) => void;
  disabled?: boolean;
}) {
  const [tipos, setTipos] = useState<TipoHonorario[]>([]);

  useEffect(() => {
    api
      .get<{ items: TipoHonorario[] }>("/catalogos-estudio/tipos-honorario")
      .then((d) => setTipos(d.items.filter((t) => t.activo)))
      .catch(() => undefined);
  }, []);

  if (tipos.length === 0) {
    return (
      <Input
        value={valor}
        disabled={disabled}
        onChange={(e) => onCambiar(e.target.value)}
        placeholder="Primera Instancia"
      />
    );
  }

  return (
    <Select value={valor} disabled={disabled} onChange={(e) => onCambiar(e.target.value)}>
      <option value="">Seleccionar…</option>
      {tipos.map((t) => (
        <option key={t.id} value={t.nombre}>
          {t.nombre}
        </option>
      ))}
    </Select>
  );
}
